import { extractApiError, type HttpApiClient } from "@vana/core";
import { type Summary } from "../../domain/entities/summary";
import { GetSummaryError } from "../../domain/errors/errors";
import { type SummaryRepository } from "../../domain/repos/summary-repo";
import { type SummaryResponse } from "../../infrastructure/responses/summary-responses";

const empty: Summary = {
  businessDate: "",
  kpis: { deliveriesTotal: 0, inRoute: 0, delivered: 0, late: 0, reportsPending: 0 },
  ambassadors: [],
  alerts: [],
};

export class SummaryRepo implements SummaryRepository {
  constructor(private readonly apiClient: HttpApiClient) {}

  async getSummary(supervisorId: string, businessDate: string): Promise<Summary> {
    try {
      const query = `?supervisor_id=${encodeURIComponent(supervisorId)}&business_date=${encodeURIComponent(businessDate)}`;
      const response = await this.apiClient.get<SummaryResponse>(`v1/supervisor/summary${query}`);
      return response.data ?? empty;
    } catch (error) {
      const { message, apiError } = extractApiError(error);
      throw new GetSummaryError(message, apiError);
    }
  }
}
